import { FC } from "react";
import { useTranslations } from "@jugl-web/utils";

export const DowngradeDisabledTooltip: FC<{
  planName: string;
  seatLimit: number;
}> = ({ planName, seatLimit }) => {
  const { t } = useTranslations();
  return (
    <span className="font-secondary text-sm leading-[1.5] text-white">
      {t(
        {
          id: "subscription-plans-dialog.downgrade-disabled-tooltip",
          defaultMessage:
            "{planName} require to have {seatLimit} Workspace Members. Currently Workspace seats exceeds {planName} Plan limit. {removeMembers} to downgrade",
        },
        {
          planName: <span className="font-semibold">{planName}</span>,
          seatLimit: <span className="font-semibold">{seatLimit}</span>,
          removeMembers: (
            <span className="underline">
              {t({
                id: "subscription-plans-dialog.remove-members-or-invitations",
                defaultMessage: "Remove members or invitations",
              })}
            </span>
          ),
        }
      )}
    </span>
  );
};
